import React, { Component } from "react";

export const Checkbox = props => {
	const { className, id, label, checked, changeAction } = props;

	return (
		<p className="flex -h -s">
      <input
      	className="filled-in"
      	type="checkbox"
      	id={id}
      	checked={checked}
      	onChange={changeAction}
    	/>
      <label htmlFor={id}>{label}</label>
    </p>
	);
};


// WEBPACK FOOTER //
// src/atoms/lib/Checkbox.js